const capabilities = {
    app: ['loader', 'error-logger'],
    entity: []
};

export default capabilities;
